import { getNewNode } from "../NodeService";
import { NodeType, PageNode } from "../../types/PageNode";
import { ADULT_BADGE_ATTRIBUTE } from "./constants";

export default class AdultBadgeNodeFactory {
    public static getNode = (parentNode: PageNode) => {
        return getNewNode(NodeType.TextNode, parentNode, {
            tagName: "span",
            value: "18+",
            classes: ["badge", "rounded-3", "ms-2", "align-self-center", "fw-bold", "fs-7"],
            customStyle: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#F8A40F",
                color: "#ffffff",
                padding: "3.5px 7px",
                lineHeight: "1",
            },
            attributes: {
                [ADULT_BADGE_ATTRIBUTE]: "true",
            },
            disallowedAddElements: true,
            isNonEditable: true,
        });
    };
}
